import React, { useReducer } from 'react';
import UsuarioContext from './usuarioContext';
import UsuarioReducer from './usuarioReducer';

import clienteAxios from '../../service/axios';

import {
    OBTENER_USUARIOS,
    OBTENER_USUARIOS_ROL,
    AGREGAR_USUARIO,
    ELIMINAR_USUARIO,
    ACTUALIZAR_USUARIO,
    USUARIO_ERROR,
    USUARIO_OK,
    USUARIO_ACTUAL,
    OBTENER_USUARIO,
    OBTENER_TABLA_USUARIO,
    OBTENER_ESTADO_SOPORTE
} from 'types/context';

const UsuarioState = props => {
    const initialState = {
        usuarios: [], // usuarios del cliente
        usuario: null,
        soporteActivo: false,
        cliente: null,
        formulario: false,
        errorformulario: false,
        mensaje: null
    }

    const [state, dispatch] = useReducer(UsuarioReducer, initialState);

    // Obtener los Usuarios
    const obtenerUsuarios = async (clienteId, indice) => {
        try {
            // siempre deberia venir un cliente
            let resultado;
            if (clienteId && indice) {
                resultado = await clienteAxios.get(`/usuarios?cliente=${clienteId}`,
                    {
                        params: {
                            pagina: indice,
                            tamanioPagina: 5,
                        },
                    });
            } else if (clienteId && !indice) {
                resultado = await clienteAxios.get(`/usuarios?cliente=${clienteId}`)
            } else {
                resultado = await clienteAxios.get('/usuarios');
            }

            //console.log(resultado);
            dispatch({
                type: OBTENER_USUARIOS,
                payload: resultado.data.usuarios.rows
            });
            //console.log("Obtener Usuarios")
            return resultado.data.usuarios.rows;
        } catch (error) {
            const alerta = {
                msg: error.response.data.message,
                categoria: 'error'
            }
            dispatch({
                type: USUARIO_ERROR,
                payload: alerta
            })
        }
    }

    // Obtener los Usuarios
    const obtenerUsuariosTabla = async (clienteId, indice) => {
        try {
            // siempre deberia venir un cliente
            let resultado;
            if (clienteId && indice) {
                resultado = await clienteAxios.get(`/usuarios/tablaUsuarios?id=${clienteId}`,
                    {
                        params: {
                            pagina: indice,
                            tamanioPagina: 5,
                        },
                    });
            } else if (clienteId && !indice) {
                resultado = await clienteAxios.get(`/usuarios/tablaUsuarios?id=${clienteId}`);
            }
            //console.log(resultado);
            dispatch({
                type: OBTENER_TABLA_USUARIO,
                payload: resultado.data.usuarios
            });
            //console.log("Obtener Usuarios")
            return resultado.data;
        } catch (error) {
            const alerta = {
                msg: error.response.data.message,
                categoria: 'error'
            }
            dispatch({
                type: USUARIO_ERROR,
                payload: alerta
            })
        }
    }
    // Obtener los Usuarios
    const obtenerUsuariosRol = async (nombreRol) => {
        try {
            
            if (!nombreRol) {
                dispatch({
                    type: OBTENER_USUARIOS_ROL,
                    payload: []
                })
                return []
            }

            let resultado = await clienteAxios.get(`/usuarios?rol=${nombreRol}`);

            dispatch({
                type: OBTENER_USUARIOS_ROL,
                payload: resultado?.data?.usuarios?.rows || []
            });
            
            return resultado?.data?.usuarios?.rows || []
        } catch (error) {
            const alerta = {
                msg: error.response.data.message,
                categoria: 'error'
            }
            dispatch({
                type: USUARIO_ERROR,
                payload: alerta
            })
        } 
    }

    // Agregar nuevo usuario
    const agregarUsuario = async usuario => {
        try {
            const resultado = await clienteAxios.post('/usuarios', usuario);
            // Insertar el usuario en el estado
            dispatch({
                type: AGREGAR_USUARIO,
                payload: resultado.data.usuario
            });
            const alerta = {
                msg: "Usuario creado con exito",
                categoria: 'exito'
            }
            dispatch({
                type: USUARIO_OK,
                payload: alerta
            })
            return resultado.status
        } catch (error) {
            const alerta = {
                msg: 'La operación no pudo concretarse!',
                categoria: 'error'
            }

            dispatch({
                type: USUARIO_ERROR,
                payload: alerta
            })
        }
    }
    // Selecciona el usuario que el usuario dio click
    const usuarioActual = usuarioId => {
        dispatch({
            type: USUARIO_ACTUAL,
            payload: usuarioId
        })
    }

    // Elimina un usuario
    const eliminarUsuario = async usuarioId => {
        try {
            const resultado = await clienteAxios.delete(`/usuarios/${usuarioId}`);
            dispatch({
                type: ELIMINAR_USUARIO,
                payload: resultado.data.usuarioId
            });
            const alerta = {
                msg: "Usuario eliminado con exito",
                categoria: 'exito'
            }

            dispatch({
                type: USUARIO_OK,
                payload: alerta
            })
            return resultado.status
        } catch (error) {
            const alerta = {
                msg: error.response.data.message,
                categoria: 'error'
            }

            dispatch({
                type: USUARIO_ERROR,
                payload: alerta
            })
        }
    }

    // Actualizar usuario
    const actualizarUsuario = async usuario => {
        try {
            const resultado = await clienteAxios.put(`/usuarios/${usuario.id}`, usuario);
            // Actualizo el disp en el state
            dispatch({
                type: ACTUALIZAR_USUARIO,
                payload: resultado.data.usuario
            })

            const alerta = {
                msg: "Usuario actualizado con exito",
                categoria: 'exito'
            }

            dispatch({
                type: USUARIO_OK,
                payload: alerta
            })
            return resultado.status
        } catch (error) {
            const alerta = {
                msg: error.response.data.message,
                categoria: 'error'
            }

            dispatch({
                type: USUARIO_ERROR,
                payload: alerta
            })
        }
    }

    const actualizarClienteRolUsuario = async (idUsuario, clienteRol) => {
        /* TODO Soporte   //console.log('USER: ',usuario);
          try {
              const resultado = await  clienteAxios.put(`usuario/clienteRol/${idUsuario}`, clienteRol);
              //console.log(resultado);
              // Actualizo el disp en el state
              dispatch({
                  type: ACTUALIZAR_USUARIO,
                  payload: resultado.data.usuario
              });
              return resultado.data.usuario;
          } catch (error) {
              const alerta = {
                  msg: error.response.data.message,
                  categoria: 'error'
              }
              
              dispatch({
                  type: USUARIO_ERROR,
                  payload: alerta
              })
          } */
    }
    const obtenerEstadoDeSoporte = async () => {
        //TODO SOPORTE 
        /*  try {
             const resultado = await  clienteAxios.get(`/soporte/estado`);
            
             //en caso de error del endpoint retorno false 
             //para que no crashee la pagina
             if (resultado.data){
                 dispatch({
                     type: OBTENER_ESTADO_SOPORTE,
                     payload: resultado.data.soporteActivo
                 });
                 return resultado.data.soporteActivo ? resultado.data.soporteActivo : false
             }else {
                 dispatch({
                     type: OBTENER_ESTADO_SOPORTE,
                     payload: false
                 });
                 return false
             }
         } catch (error) {
             dispatch({
                 type: OBTENER_ESTADO_SOPORTE,
                 payload: false
             });
             return false
         } */
    }
    //exito
    const okUsuario = (msj, categoria) => {
        const alerta = {
            msg: msj,
            categoria: categoria
        };
        dispatch({
            type: USUARIO_OK,
            payload: alerta
        });
    };

    // muestra un error de validacion
    const clearOkUsuario = () => {
        dispatch({
            type: USUARIO_OK,
            payload: null,
        });
    };


    // muestra un error de validacion
    const errorUsuario = (msj, categoria) => {
        const alerta = {
            msg: msj,
            categoria: categoria
        };
        dispatch({
            type: USUARIO_ERROR,
            payload: alerta
        });
    };

    // muestra un error de validacion
    const clearErrorUsuario = () => {
        dispatch({
            type: USUARIO_ERROR,
            payload: null,
        });
    };

    // Obtengo un usuario por id
    const obtenerUsuario = async (usuarioId) => {
        try {

            const resultado = await clienteAxios.get(`/usuario?id=${usuarioId}`);
            dispatch({
                type: OBTENER_USUARIO,
                payload: resultado.data.usuario
            })
            return resultado.data.usuario;

        } catch (error) {
            const alerta = {
                msg: error.response.data.message,
                categoria: 'error'
            }
            dispatch({
                type: USUARIO_ERROR,
                payload: alerta
            })
        }
    }

    return (
        <UsuarioContext.Provider
            value={{
                usuarios: state.usuarios,
                usuario: state.usuario,
                cliente: state.cliente,
                formulario: state.formulario,
                errorformulario: state.errorformulario,
                mensaje: state.mensaje,
                soporteActivo: state.soporteActivo,
                obtenerUsuarios,
                agregarUsuario,
                obtenerEstadoDeSoporte,
                usuarioActual,
                eliminarUsuario,
                clearErrorUsuario,
                clearOkUsuario,
                actualizarUsuario,
                errorUsuario,
                okUsuario,
                obtenerUsuario,
                obtenerUsuariosRol,
                actualizarClienteRolUsuario,
                obtenerUsuariosTabla
            }}
        >{props.children}

        </UsuarioContext.Provider>
    )
}
export default UsuarioState;
